var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 491,
    viewBox: "0 0 480 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 491C372.548 491 480 383.324 480 250.5C480 117.676 372.548 10 240 10C107.452 10 0 117.676 0 250.5C0 383.324 107.452 491 240 491Z",
    fill: "url(#paint0_linear_37_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 363C305.74 363 387 281.74 387 181.5C387 81.2603 305.74 0 205.5 0C105.26 0 24 81.2603 24 181.5C24 281.74 105.26 363 205.5 363Z",
    fill: "url(#paint1_linear_37_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_37_24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_24",
    x1: 240,
    y1: -111.663,
    x2: 240,
    y2: 635.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    stopColor: "#1E1581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0A30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_24",
    x1: 205.5,
    y1: -91.8161,
    x2: 205.5,
    y2: 472.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2484,
    stopColor: "#0E0A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3927,
    stopColor: "#100B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    stopColor: "#130D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6137,
    stopColor: "#17105D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7067,
    stopColor: "#1C1476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7387,
    stopColor: "#1E1581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E15C5"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_37_24",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAtQAAALUCAYAAAArLaXwAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOval);
export default __webpack_public_path__ + "static/media/ic_oval.e2286c7493f12dcd5498c0fc7a0d98f8.svg";
export { ForwardRef as ReactComponent };